export const UI = {
  tr: {
    services: "Hizmetler", branches: "Şubeler", projects: "Projeler", contact: "İletişim",
    getQuote: "Teklif Al", home: "Ana Sayfa", menu: "Menü",
    langUnavailable: "Bu dilde mevcut değil",
    heroCtaSecondary: "Hizmetleri Keşfet",
    ourServices: "Hizmetlerimiz", ourBranches: "Şubelerimiz",
    quoteTitle: "Ücretsiz Teklif Alın", quoteSubtitle: "Aracınız için hızlı ve ücretsiz fiyat teklifi.",
    name: "Ad Soyad", phone: "Telefon", whatsapp: "WhatsApp", email: "E-posta",
    brand: "Araç Markası", model: "Model", year: "Yıl", service: "Hizmet", branch: "Şube",
    message: "Mesajınız", selectService: "Hizmet seçin", selectBranch: "Şube seçin",
    send: "Gönder", sending: "Gönderiliyor...", successMsg: "Talebiniz alındı! En kısa sürede dönüş yapacağız.",
    continueWhatsapp: "WhatsApp ile devam et",
    contactInfo: "İletişim Bilgileri", address: "Adres", hours: "Çalışma Saatleri",
    infoSoon: "Bu şube için iletişim bilgileri yakında eklenecek.",
    notFound: "Sayfa bulunamadı", notFoundText: "Aradığınız sayfa mevcut değil.", backHome: "Ana sayfaya dön",
    rights: "Tüm hakları saklıdır.", langBanner: "Türkçe olarak görüntülemek ister misiniz?",
    accept: "Evet", dismiss: "Kapat", faqTitle: "Sıkça Sorulan Sorular",
    blog: "Blog", readMore: "Devamını oku", backToBlog: "Tüm yazılara dön",
    blogEmpty: "Henüz yazı yok. Yakında burada olacak.",
    allCategories: "Tümü", writtenBy: "Yazan:",
    galleryInstagram: "Tüm çalışmalarımızı Instagram'da görebilirsiniz:",
    heroBadge1Title: "Sertifikalı Uygulama", heroBadge1Sub: "Her işte kalite garantisi",
    heroBadge2Title: "Seramik & PPF Koruma", heroBadge2Sub: "Uzun ömürlü koruma",
    whyServicesFallback: "Premium malzemeler ve uzman işçilik.",
    whyRating: "Projelerle kanıtlanmış kalite ve müşteri memnuniyeti.",
    whyBranches: "Girne, Lefkoşa ve Mağusa'da hizmetinizdeyiz.",
  },
  en: {
    services: "Services", branches: "Branches", projects: "Projects", contact: "Contact",
    getQuote: "Get a Quote", home: "Home", menu: "Menu",
    langUnavailable: "Not available in this language",
    heroCtaSecondary: "Explore Services",
    ourServices: "Our Services", ourBranches: "Our Branches",
    quoteTitle: "Get a Free Quote", quoteSubtitle: "A fast, free price estimate for your car.",
    name: "Full Name", phone: "Phone", whatsapp: "WhatsApp", email: "Email",
    brand: "Vehicle Brand", model: "Model", year: "Year", service: "Service", branch: "Branch",
    message: "Your Message", selectService: "Select a service", selectBranch: "Select a branch",
    send: "Send", sending: "Sending...", successMsg: "Request received! We'll get back to you shortly.",
    continueWhatsapp: "Continue on WhatsApp",
    contactInfo: "Contact Information", address: "Address", hours: "Opening Hours",
    infoSoon: "Contact details for this branch will be added soon.",
    notFound: "Page not found", notFoundText: "The page you are looking for does not exist.", backHome: "Back to home",
    rights: "All rights reserved.", langBanner: "Would you like to view this in English?",
    accept: "Yes", dismiss: "Dismiss", faqTitle: "Frequently Asked Questions",
    blog: "Blog", readMore: "Read more", backToBlog: "Back to all articles",
    blogEmpty: "No articles yet. Check back soon.",
    allCategories: "All", writtenBy: "By",
    galleryInstagram: "See all our work on Instagram:",
    heroBadge1Title: "Certified Application", heroBadge1Sub: "Quality guaranteed on every job",
    heroBadge2Title: "Ceramic & PPF Protection", heroBadge2Sub: "Long-lasting protection",
    whyServicesFallback: "Premium materials and expert craftsmanship.",
    whyRating: "Quality and customer satisfaction proven by our projects.",
    whyBranches: "At your service in Kyrenia, Nicosia and Famagusta.",
  },
  el: {
    services: "Υπηρεσίες", branches: "Υποκαταστήματα", projects: "Έργα", contact: "Επικοινωνία",
    getQuote: "Λάβετε Προσφορά", home: "Αρχική", menu: "Μενού",
    langUnavailable: "Μη διαθέσιμο σε αυτή τη γλώσσα",
    heroCtaSecondary: "Δείτε τις Υπηρεσίες",
    ourServices: "Οι Υπηρεσίες μας", ourBranches: "Τα Υποκαταστήματά μας",
    quoteTitle: "Λάβετε Δωρεάν Προσφορά", quoteSubtitle: "Γρήγορη, δωρεάν εκτίμηση για το αυτοκίνητό σας.",
    name: "Ονοματεπώνυμο", phone: "Τηλέφωνο", whatsapp: "WhatsApp", email: "Email",
    brand: "Μάρκα", model: "Μοντέλο", year: "Έτος", service: "Υπηρεσία", branch: "Υποκατάστημα",
    message: "Μήνυμα", selectService: "Επιλέξτε υπηρεσία", selectBranch: "Επιλέξτε υποκατάστημα",
    send: "Αποστολή", sending: "Αποστολή...", successMsg: "Το αίτημα ελήφθη! Θα επικοινωνήσουμε σύντομα.",
    continueWhatsapp: "Συνέχεια στο WhatsApp",
    contactInfo: "Στοιχεία Επικοινωνίας", address: "Διεύθυνση", hours: "Ώρες Λειτουργίας",
    infoSoon: "Τα στοιχεία επικοινωνίας θα προστεθούν σύντομα.",
    notFound: "Η σελίδα δεν βρέθηκε", notFoundText: "Η σελίδα που ζητήσατε δεν υπάρχει.", backHome: "Επιστροφή στην αρχική",
    rights: "Με επιφύλαξη παντός δικαιώματος.", langBanner: "Θέλετε να το δείτε στα Ελληνικά;",
    accept: "Ναι", dismiss: "Κλείσιμο", faqTitle: "Συχνές Ερωτήσεις",
    blog: "Blog", readMore: "Διαβάστε περισσότερα", backToBlog: "Πίσω σε όλα τα άρθρα",
    blogEmpty: "Δεν υπάρχουν άρθρα ακόμη. Ελάτε σύντομα ξανά.",
    allCategories: "Όλα", writtenBy: "Από",
    galleryInstagram: "Δείτε όλες τις δουλειές μας στο Instagram:",
    heroBadge1Title: "Πιστοποιημένη Εφαρμογή", heroBadge1Sub: "Ποιότητα σε κάθε εργασία",
    heroBadge2Title: "Προστασία Κεραμικής & PPF", heroBadge2Sub: "Μακράς διαρκείας προστασία",
    whyServicesFallback: "Premium υλικά και εξειδικευμένη τεχνογνωσία.",
    whyRating: "Ποιότητα και ικανοποίηση πελατών αποδεδειγμένη μέσα από τα έργα μας.",
    whyBranches: "Στη διάθεσή σας σε Κερύνεια, Λευκωσία και Αμμόχωστο.",
  },
  ru: {
    services: "Услуги", branches: "Филиалы", projects: "Проекты", contact: "Контакты",
    getQuote: "Получить расчёт", home: "Главная", menu: "Меню",
    langUnavailable: "Недоступно на этом языке",
    heroCtaSecondary: "Смотреть услуги",
    ourServices: "Наши услуги", ourBranches: "Наши филиалы",
    quoteTitle: "Получите бесплатный расчёт", quoteSubtitle: "Быстрая бесплатная оценка для вашего автомобиля.",
    name: "Имя и фамилия", phone: "Телефон", whatsapp: "WhatsApp", email: "Эл. почта",
    brand: "Марка", model: "Модель", year: "Год", service: "Услуга", branch: "Филиал",
    message: "Сообщение", selectService: "Выберите услугу", selectBranch: "Выберите филиал",
    send: "Отправить", sending: "Отправка...", successMsg: "Заявка получена! Мы скоро свяжемся с вами.",
    continueWhatsapp: "Продолжить в WhatsApp",
    contactInfo: "Контактная информация", address: "Адрес", hours: "Часы работы",
    infoSoon: "Контактные данные этого филиала скоро появятся.",
    notFound: "Страница не найдена", notFoundText: "Запрашиваемая страница не существует.", backHome: "На главную",
    rights: "Все права защищены.", langBanner: "Показать на русском языке?",
    accept: "Да", dismiss: "Закрыть", faqTitle: "Частые вопросы",
    blog: "Блог", readMore: "Читать далее", backToBlog: "Ко всем статьям",
    blogEmpty: "Пока нет статей. Загляните позже.",
    allCategories: "Все", writtenBy: "Автор:",
    galleryInstagram: "Все наши работы смотрите в Instagram:",
    heroBadge1Title: "Сертифицированная работа", heroBadge1Sub: "Качество в каждой работе",
    heroBadge2Title: "Защита керамикой и PPF", heroBadge2Sub: "Долговременная защита",
    whyServicesFallback: "Премиальные материалы и экспертное мастерство.",
    whyRating: "Качество и удовлетворённость клиентов, подтверждённые нашими проектами.",
    whyBranches: "К вашим услугам в Кирении, Никосии и Фамагусте.",
  },
  fa: {
    services: "خدمات", branches: "شعبه‌ها", projects: "پروژه‌ها", contact: "تماس",
    getQuote: "دریافت قیمت", home: "خانه", menu: "منو",
    langUnavailable: "در این زبان موجود نیست",
    heroCtaSecondary: "مشاهده خدمات",
    ourServices: "خدمات ما", ourBranches: "شعبه‌های ما",
    quoteTitle: "دریافت قیمت رایگان", quoteSubtitle: "برآورد سریع و رایگان برای خودروی شما.",
    name: "نام و نام خانوادگی", phone: "تلفن", whatsapp: "واتساپ", email: "ایمیل",
    brand: "برند خودرو", model: "مدل", year: "سال", service: "خدمت", branch: "شعبه",
    message: "پیام شما", selectService: "یک خدمت انتخاب کنید", selectBranch: "یک شعبه انتخاب کنید",
    send: "ارسال", sending: "در حال ارسال...", successMsg: "درخواست شما دریافت شد! به‌زودی با شما تماس می‌گیریم.",
    continueWhatsapp: "ادامه در واتساپ",
    contactInfo: "اطلاعات تماس", address: "آدرس", hours: "ساعات کاری",
    infoSoon: "اطلاعات تماس این شعبه به‌زودی اضافه می‌شود.",
    notFound: "صفحه یافت نشد", notFoundText: "صفحه‌ای که به دنبال آن هستید وجود ندارد.", backHome: "بازگشت به خانه",
    rights: "تمام حقوق محفوظ است.", langBanner: "آیا مایلید این را به فارسی ببینید؟",
    accept: "بله", dismiss: "بستن", faqTitle: "پرسش‌های متداول",
    blog: "بلاگ", readMore: "ادامه مطلب", backToBlog: "بازگشت به همه مقالات",
    blogEmpty: "هنوز مقاله‌ای وجود ندارد. به‌زودی سر بزنید.",
    allCategories: "همه", writtenBy: "نویسنده:",
    galleryInstagram: "همه کارهای ما را در اینستاگرام ببینید:",
    heroBadge1Title: "اجرای گواهی‌شده", heroBadge1Sub: "تضمین کیفیت در هر کار",
    heroBadge2Title: "محافظت سرامیک و PPF", heroBadge2Sub: "محافظت طولانی‌مدت",
    whyServicesFallback: "متریال درجه‌یک و مهارت تخصصی.",
    whyRating: "کیفیت و رضایت مشتری، اثبات‌شده با پروژه‌های ما.",
    whyBranches: "در گیرنه، لفکوشا و ماغوسا در خدمت شما هستیم.",
  },
};

export const LANG_NAMES = { tr: "Türkçe", en: "English", el: "Ελληνικά", ru: "Русский", fa: "فارسی" };
export const t = (lang, key) => (UI[lang] || UI.tr)[key] || (UI.tr[key] || key);
